import { useConfigConditionValue } from 'features/config/useConfigConditionValue'
import { usePastDeals } from 'hooks/usePastDeals'
import useSession from 'hooks/useSession'
import React from 'react'
import { ScrollView } from 'react-native'
import cn from '@ui/utils/cn'

import { Deal } from '@ca/common/types'
import DealsExtra from './DealsExtra'
import DealsIntro from './DealsIntro'

export default function IntroDeals({
  independent,
  more = true,
  hideBrand,
  onSelect,
}: {
  hideBrand?: boolean
  independent?: boolean
  more?: boolean
  onSelect?: (deal: Deal) => void
}) {
  const pastDeals = usePastDeals()

  const pendingOrder = useSession((s) => s.pendingOrder) // mockPendingOrder

  const tagsConfig = useConfigConditionValue(
    pastDeals.value ? 'intro:all.tags' : 'intro:tags',
    'tags'
  )

  const activeTagsConfig = useConfigConditionValue('intro:active.tags', 'tags')

  return (
    <>
      <ScrollView
        className="h-full w-full bg-white"
        contentContainerClassName={cn('flex w-full', false && 'h-full')}
      >
        {!pendingOrder && tagsConfig && (
          <DealsIntro
            independent={independent}
            active={activeTagsConfig}
            config={tagsConfig}
            onSelect={onSelect}
            hideBrand={hideBrand}
            more={more}
          />
        )}
        {pendingOrder?.uiMode === 'select' && tagsConfig && (
          <DealsIntro
            independent={independent}
            active={activeTagsConfig}
            config={tagsConfig}
            onSelect={onSelect}
            hideBrand={hideBrand}
            more={more}
            hidden={true}
            // Treat the tag as a required tag
            requiredTags={
              pendingOrder.deal.filter?.tag
                ? [pendingOrder.deal.filter?.tag]
                : undefined
            }
            initial={{
              type: pendingOrder.deal.filter?.type,
              past_deals: '1',
              tags_excluded: pendingOrder.deal.filter?.tagsExcluded?.join(','),
              price: pendingOrder.deal.filter?.price,
            }}
          />
        )}
        {/* Pending order */}
        {pendingOrder && pendingOrder.uiMode !== 'select' && (
          <DealsExtra pending={pendingOrder} />
        )}
      </ScrollView>
    </>
  )
}
